import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Shield01 = function Shield01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.302 21.6147c.2214.1292.3321.1938.4883.2273.1213.026.2981.026.4194 0 .1562-.0335.2669-.0981.4883-.2273C14.646 20.4783 20 16.9083 20 11.9999V7.2175c0-.7995 0-1.1993-.1308-1.543a2 2 0 0 0-.5469-.7891c-.2758-.243-.6501-.3834-1.3987-.6642l-5.3618-2.0107c-.2079-.078-.3118-.1169-.4188-.1324a1 1 0 0 0-.286 0c-.107.0155-.2109.0545-.4188.1324L6.0764 4.2212c-.7486.2808-1.1229.4211-1.3987.6642a2 2 0 0 0-.547.7892C4 6.0182 4 6.418 4 7.2175v4.7824c0 4.9084 5.354 8.4784 7.302 9.6148"
    })
  }));
};
export default Shield01;